import React from 'react';
import { STATS } from '../../data/credibility.mjs';
import CountUp from '../../motion/CountUp';
import './credibility.css';

/**
 * Barra de estadísticas bajo el hero de la portada.
 * Sólo renderiza los items con `value !== null` (no se inventan cifras).
 */
const StatsBar = ({ stats = STATS }) => {
    const visible = stats.filter((s) => s.value !== null && s.value !== undefined && s.value !== '');
    if (visible.length === 0) return null;
    const col = visible.length >= 4 ? 'col-6 col-md-3' : visible.length === 3 ? 'col-12 col-md-4' : 'col-12 col-md-6';
    return (
        <section className="stats-bar" aria-label="Cifras de Coralan Multiservice">
            <div className="container">
                <div className="row justify-content-center">
                    {visible.map((s, i) => (
                        <div className={`${col} stats-bar__item`} key={s.label} data-reveal="up" data-reveal-delay={String(i + 1)}>
                            <span className="stats-bar__value"><CountUp value={s.value} /></span>
                            <span className="stats-bar__label">{s.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsBar;
